import { decodeJwt } from 'jose';
import { AuthPayload } from '../@types/auth';

export const decodePayload = (token: string): AuthPayload => {
    try {
        return decodeJwt(token) as AuthPayload;
    } catch (err) {
        const name = err instanceof Error ? err.name : 'unknown';
        const message = err instanceof Error ? err.message : String(err);
        console.error('[decodePayload] JWT decode failed', { name, message });
        throw err;
    }
};
